import { BaseSDKShape } from '../BaseSDKShape';
import { PlatformSDKShape } from '../PlatformSDKShape';
import { ControllersErrorCode, createControllersError } from './errors';

interface AppController {
  type: string;
  settings: Record<string, any>;
  update: (settings: Record<string, any>) => void;
}

export class ControllersSDKShape extends BaseSDKShape {
  async #getSelectedComponentRef() {
    const privateAPI = await this.getPlatformPrivateAPI();
    const refs = await privateAPI.components.getSelectedComponents();
    const compRef = refs[0];

    if (!compRef) {
      throw createControllersError(ControllersErrorCode.UndefinedCompRef);
    }

    return compRef;
  }
  async get(): Promise<AppController[]> {
    const privateAPI = await this.getPlatformPrivateAPI();
    return privateAPI.controllers.get(
      await this.getAppDefinitionId(),
      await this.#getSelectedComponentRef(),
    );
  }
}

export default new PlatformSDKShape(ControllersSDKShape)
  .withPublicMethod('get')
  .build();
